module.exports = __webpack_public_path__ + "static/media/Bagus2.3e64793d.JPG";